import { gql } from '@apollo/client';

export const MUTATION_REGISTER_OR_UPDATE_DYNAMIC_OBJECT = gql`
    mutation RegisterOrUpdateDynamicObject($data: RegisterOrUpdateDynamicObjectsWithValuesInput!) {
        registerOrUpdateDynamicObject(data: $data) {
            id
            objectDefinition {
                id
                objectProperties {
                    id
                    name
                    order
                    isDisplayable
                    isRequired
                    enabled
                    dataType
                }
            }
            objectValues {
                value
                tag
                objectProperty {
                    id
                    dataType
                    name
                    order
                    isDisplayable
                }
            }
        }
    }
`;

export const BULK_CREATE_DYNAMIC_OBJECT = gql`
    mutation BulkCreateDynamicObjects($data: [RegisterOrUpdateDynamicObjectsWithValuesInput!]!) {
        bulkCreateDynamicObjects(data: $data) {
            id
            enabled
            tempId
            objectDefinition {
                id
                name
            }
            objectValues {
                objectProperty {
                    id
                    name
                    dataType
                }
                value
                listsValues {
                    id
                    value
                }
                tag
            }
            createdAt
            updatedAt
        }
    }
`;
